<script>
  import { push } from "svelte-spa-router"
  import Navbar from "../../../../Shared/Navbar/index.svelte"
  import Footer from "../../../../Shared/footer.svelte"
  let animate = [
    {
      ball1: Math.random() * 100,
      delay: Math.random() * 7 + 1,
    },
    {
      ball2: Math.random() * 100,
      delay: Math.random() * 4 + 1,
    },
    {
      ball3: Math.random() * 100,
      delay: Math.random() * 11 + 1,
    },
    {
      ball4: Math.random() * 100,
      delay: Math.random() * 1 + 1,
    },
  ]
</script>

<svelte:head>
  <title>Settings Security</title>
</svelte:head>

<div class="relative min-h-screen w-full bg-[#f7f7f7] dark:bg-bodyblack">
  <Navbar />

  <div class="px-6">
    <div class="mx-auto w-full max-w-[920px] select-none pb-40 pt-6">
      <div class="relative mt-6 flex min-h-[470px] flex-col items-center justify-center rounded-md bg-white p-6 dark:bg-mdGray md:p-12">
        <div class="relative flex h-60 w-60 items-center justify-center">
          <div class="circle h-32 w-32 rounded-full border-[#e9e9e9] dark:border-bodyblack">
            <div class="flex h-full w-full items-center justify-center">
              <div class="circle1 h-24 w-24 rounded-full border-[#eeeeee] dark:border-bodyblack">
                <div class="flex h-full w-full items-center justify-center">
                  <i class="fa-solid fa-shield-check fa-3x text-sky-500" />
                </div>
              </div>
            </div>
            <div
              on:animationiteration={() => {
                animate[0].ball1 = Math.random() * (100 - 20)
              }}
              class="circle2 absolute bottom-3 rounded-full bg-[#D9D9D9] dark:bg-gray-500"
              style="right : {animate[0].ball1}%; animation-delay:{animate[0].delay}s"
            />

            <div
              on:animationiteration={() => {
                animate[1].ball2 = Math.random() * (100 - 20)
              }}
              class="circle2 absolute top-3 rounded-full bg-[#D9D9D9] dark:bg-gray-500"
              style="left : {animate[1].ball2}% ;animation-delay:{animate[1].delay}s"
            />

            <div
              on:animationiteration={() => {
                animate[2].ball3 = Math.random() * (100 - 20)
              }}
              class="circle2 absolute right-3 rounded-full bg-[#D9D9D9] dark:bg-gray-500"
              style="top : {animate[2].ball3}% ;animation-delay:{animate[2].delay}s"
            />
            <div
              on:animationiteration={() => {
                animate[3].ball4 = Math.random() * (100 - 20)
              }}
              class="circle2 absolute left-3 rounded-full bg-[#D9D9D9] dark:bg-gray-500"
              style="bottom : {animate[3].ball4}% ;animation-delay:{animate[3].delay}s"
            />
          </div>
          <!-- <div class="absolute right-3 top-10 h-7 w-7 animate-pulse rounded-full bg-[#D9D9D9] dark:bg-bodyblack" />
        <div class="absolute bottom-10 right-3 h-4 w-4 animate-bounce rounded-full bg-[#D9D9D9] dark:bg-bodyblack" />
        <div class="absolute bottom-1/2 left-1 h-6 w-6 animate-bounce rounded-full bg-[#D9D9D9] dark:bg-bodyblack" />-->
        </div>
        <h1 class="text-center text-2xl font-bold tracking-wide text-gray-800 dark:text-white md:text-3xl">
          Password changed <br />
          successfully!
        </h1>
        <p class="pt-3 text-center text-base font-normal text-gray-200 md:text-lg">
          Your password has been changed successfully. Please note that you will remain logged in on all devices where you are currently signed in until your respective tokens expire.
          <!-- Your password has been changed successfully. <br />
        You will remain logged in on your current devices. -->
          <!-- your password has been changed successfully, we will let you know <br />
        if there are any problems with your account. -->
        </p>
        <button
          on:click={() => {
            push("/settings/integration/home")
          }}
          class="mt-3 flex h-9 w-24 min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-blue-300 md:w-32 lg:px-4"
        >
          <i class="fa-solid fa-check" />
          &nbsp;&nbsp;Okay
        </button>
      </div>
    </div>
  </div>
  <Footer />
</div>

<style lang="postcss">
  @keyframes border-animation {
    0% {
      height: 128px;
      width: 128px;
      border-width: 8px;
      /* opacity: 1; */
    }
    50% {
      border-width: 20px;
      /* opacity: 0.5; */
    }

    100% {
      height: 180px;
      width: 180px;
      border-width: 25px;
      /* opacity: 1; */
    }
  }
  @keyframes card-animation {
    0% {
      height: 96px;
      width: 96px;
      /* opacity: 1; */
    }
    50% {
      /* height: 75px;
      width: 75px; */
      height: 84px;
      width: 84px;
      /* opacity: 0.5; */
    }

    100% {
      height: 110px;
      width: 110px;
      /* opacity: 1; */
    }
  }

  .circle {
    animation: border-animation 3s alternate infinite cubic-bezier(0, 0, 0.5, 1);
  }
  .circle1 {
    animation: card-animation 3s 1s alternate infinite cubic-bezier(0, 0, 0.5, 1);
  }
  /* random balls generation */
  @keyframes card-animation1 {
    0% {
      height: 0px;
      width: 0px;
      opacity: 1;
    }
    100% {
      height: 40px;
      width: 40px;
      opacity: 0.1;
    }
  }

  .circle2 {
    animation: card-animation1 3s infinite linear;
  }
</style>
